module.exports = __webpack_public_path__ + "e8e4e64c3ecdae778cd4777c08fc6cce.png";